// Portal absorption (WS-D1) — the vendor "Notifications" tab: every
// broadcast delivered to the vendor's linked portal account, with read
// state (the shared AccountNotificationsPanel).

import { EmptyState } from "@/design-system/components/ui";
import { AccountNotificationsPanel } from "@/components/portalAbsorption/AccountNotificationsPanel";
import type { VendorDto } from "@/api/portfolioAdmin/types";
import { useVendorPortalAccount } from "@/hooks/portfolioAdmin/useRegistries";

export function VendorPortalNotificationsTab({ vendor }: { vendor: VendorDto }) {
  const portalQuery = useVendorPortalAccount(vendor.id);
  const portalUserId = portalQuery.data?.portalUserId ?? null;

  if (portalQuery.isLoading) {
    return <p className="text-caption text-gray-mid">Loading portal account…</p>;
  }
  if (!portalUserId) {
    return (
      <EmptyState
        title="No portal account"
        description="This vendor has no portal account yet — send the portal invitation from the Portal account tab first."
      />
    );
  }
  return <AccountNotificationsPanel portalUserId={portalUserId} />;
}
